export default (
  state = { value: null, isloading: false, filled: false },
  action
) => {
  switch (action.type) {
    case 'FETCH_SHIPPING':
      return { ...state, isloading: true, filled: false }
    case 'FETCH_SHIPPING_SUCCESS':
      return {
        ...state,
        isloading: false,
        value: { ...action.payload.data },
        filled: true
      }
    case 'FETCH_SHIPPING_FAIL':
      return {
        ...state,
        isloading: false,
        value: {},
        error: action.error.data,
        filled: false
      }
    case 'RESET_SHIPPING':
      return {
        ...state,
        isloading: false,
        value: {},
        filled: false
      }

    case 'ERROR_FILLED_SHIPPING':
      return {
        ...state,
        isloading: false,
        value: {},
        error: { data: 'CEP invalido' },
        filled: false
      }
    default:
      return { ...state }
  }
}

export const getShipping = ({ shipping }) => {
  return {
    isloading: shipping.isloading,
    value: shipping.value,
    filled: shipping.filled,
    error: shipping.error,
    visible: true
  }
}



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Shipping/reducer.js